/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAzureSecurityGraph extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAzureSecurityGraph");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAzureSecurityGraph.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAzureSecurityGraph>): BackgroundJobPayloadForPeriodicAzureSecurityGraph {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAzureSecurityGraph(), model);
        BackgroundJobPayloadForPeriodicAzureSecurityGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAzureSecurityGraph>): BackgroundJobPayloadForPeriodicAzureSecurityGraph {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAzureSecurityGraph.newInstance(<BackgroundJobPayloadForPeriodicAzureSecurityGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAzureSecurityGraph) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAzureSecurityGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAzureSecurityGraph): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAzureSecurityGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
